import axiosInstance from "./axiosInstance";

let api = axiosInstance()


export const getAllDepartments = async(abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/Industry`, config)
  }

export const getByCriteria = async(id, abortToken)=>{
    console.log(id);
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/Job/ByCriteria/${id}`, config)
  }